import { Fragment, useState } from 'react';
import { IPage } from '../Components/Page';
import Home from './Home';
import { useLocation, useParams } from 'react-router';
import { eventStore, IStoreEvent } from '../Services/EventsStore';
import { scanHistory } from '../Services/ScanHistory';
import { IScanData, ValidationStatus } from '../Services/GateKeeperDb';
import { formatDate, formatValidationMessage, useInitAsync } from '../Utils';
import HistoryIcon from '@mui/icons-material/History';
import Button from '@mui/material/Button';
import { useOperation } from '../Hooks/OperationContext';
import "./ScanHistory.scss"
import { ticketValidator } from '../Services/TicketValidator';
import { useActions } from '../Hooks/Actions';

interface IScanHistoryProps {
    event?: IStoreEvent;
}

export function ScanHistoryContent(props: IScanHistoryProps) {

    const { eventId } = useParams();

    const { state } = useLocation();

    const [event, setEvent] = useState(props.event ?? (state as IScanHistoryProps)?.event);

    const [items, setItems] = useState(null as IScanData[]);

    const operation = useOperation();

    const actions = useActions();

    useInitAsync(async () => {

        if (!event && eventId)
            setEvent(await eventStore.getEventByIdAsync(eventId));

        if (event || eventId)
            setItems(await scanHistory.listAsync({ eventId: eventId ?? event?.id }));
    });

    if (!event || !items)
        return null;

    const clearHistory = async () => {

        const info = await ticketValidator.getScansToSyncAsync(eventId);
        const toSync = info.ticketsToSync?.length ?? 0;

        const confirm = await operation.confirmAsync("Sicuro di voler eliminare la cronologia delle scansioni?"
            + (toSync > 0 ? ("\n\nATTENZIONE: hai " + toSync + " titolo/i letti offline ancora dd sincronizzare.") : ""));

        if (confirm) {
            await scanHistory.clearAsync(event.id);
            setItems([]);
        }
    }

    const showDetails = (eventId: string, barcode: string) => {
        actions.ticketDetails(eventId, barcode);
    }

    return (
        <Fragment>

            <header>
                {"Cronologia Scansioni"}
                <div>
                    {items.length} Letture
                </div>
            </header>
            {(items && items.length == 0) ?
                <div className="empty-list">
                    <HistoryIcon />
                    <span>Nessuna scansione</span>
                </div>
                :
                <Fragment>
                <div className="list-view">

                    {items?.map((a, i) => {

                        let status = a.status == ValidationStatus.Valid ? {
                            color: "green",
                            text: "Valido"
                        } : {
                            color: "red",
                            text: a.verify?.msg ?? "non valido"
                        };

                        return (
                            <div key={i} className="list-item" onClick={() => showDetails(a.eventId, a.code)}>
                                <div className="main">
                                    <span className="time">{formatDate(a.timestamp)}</span>
                                    <span className="barcode">{a.code}</span>
                                </div>
                                <span className={"status " + status.color}>{formatValidationMessage(status.text, "short")}</span>
                            </div>
                        );
                    })}
                </div>
                { items?.length > 0 ?
                <Button variant="contained" onClick={clearHistory} >Cancella cronologia</Button> :
                null
                }
                </Fragment>
            }
        </Fragment>
    );
}

const ScanHistory: IPage = {

    name: "scan-history",
    title: "Cronologia Scansioni",
    route: "/scan/history/:eventId",
    container: Home,
    icon: <HistoryIcon/>,
    content: <ScanHistoryContent />,
    appBar: { backVisible: true, title: "Access Control" }
};


export default ScanHistory;